// extracted by mini-css-extract-plugin
export var footer = "_ig-0";
export var inherit = "_ig-1";
export var input = "_ig-2";
export var modalContent = "_ig-3";
export var quillEditor = "_ig-4";
export var subtitle = "_ig-5";